// src/features/stock/stockSubsectionPages.jsx
import InsumosPage from "./baseDatos/insumos/pages/InsumosPage";
import ProveedoresPage from "./baseDatos/proveedores/pages/ProveedoresPage";
import ItemsDeCompraPage from "./baseDatos/itemsDeCompra/pages/ItemsDeCompraPage";
import ElaboradosPage from "./baseDatos/elaborados/pages/ElaboradosPage";
import RecetasPage from "./baseDatos/recetas/pages/RecetasPage";
import ProductosVentaPage from "./baseDatos/productosVenta/pages/ProductosVentaPage";

import ComprasPage from "./operacion/compras/pages/ComprasPage";
import StockPage from "./operacion/stock/pages/StockPage";
import ProduccionElaboradosPage from "./operacion/produccionElaborados/pages/ProduccionElaboradosPage";
import ConteoDeStockPage from "./operacion/conteoDeStock/pages/ConteoDeStockPage";
import VentasImportadasPage from "./operacion/ventasImportadas/pages/VentasImportadasPage";

import ConsumoTeoricoPage from "./analisis/consumoTeorico/pages/ConsumoTeoricoPage";
import ConsumoRealPage from "./analisis/consumoReal/pages/ConsumoRealPage";
import CmvGeneralPage from "./analisis/cmvGeneral/pages/CmvGeneralPage";
import DesviosPage from "./analisis/desvios/pages/DesviosPage";
import ImpactoEconomicoPage from "./analisis/impactoEconomico/pages/ImpactoEconomicoPage";
import PedidoSugeridoPage from "./analisis/pedidoSugerido/pages/PedidoSugeridoPage";

import ResumenSemanalPage from "./dashboard/resumenSemanal/pages/ResumenSemanalPage";
import TopDesviosPage from "./dashboard/topDesvios/pages/TopDesviosPage";
import CmvPage from "./dashboard/cmv/pages/CmvPage";
import EvolucionPage from "./dashboard/evolucion/pages/EvolucionPage";
import AlertasPage from "./dashboard/alertas/pages/AlertasPage";

const stockSubsectionPages = {
  "base-de-datos/insumos": InsumosPage,
  "base-de-datos/proveedores": ProveedoresPage,
  "base-de-datos/items-de-compra": ItemsDeCompraPage,
  "base-de-datos/elaborados": ElaboradosPage,
  "base-de-datos/recetas": RecetasPage,
  "base-de-datos/productos-de-venta": ProductosVentaPage,
  "operacion/compras": ComprasPage,
  "operacion/stock": StockPage,
  "operacion/produccion-elaborados": ProduccionElaboradosPage,
  "operacion/conteo-de-stock": ConteoDeStockPage,
  "operacion/ventas-importadas": VentasImportadasPage,
  "analisis/consumo-teorico": ConsumoTeoricoPage,
  "analisis/consumo-real": ConsumoRealPage,
  "analisis/cmv-general": CmvGeneralPage,
  "analisis/desvios": DesviosPage,
  "analisis/impacto-economico": ImpactoEconomicoPage,
  "analisis/pedido-sugerido": PedidoSugeridoPage,
  "dashboard/resumen-semanal": ResumenSemanalPage,
  "dashboard/top-desvios": TopDesviosPage,
  "dashboard/cmv": CmvPage,
  "dashboard/evolucion": EvolucionPage,
  "dashboard/alertas": AlertasPage,
};

export function getStockSubsectionPage(sectionPath, subsectionPath) {
  return stockSubsectionPages[`${sectionPath}/${subsectionPath}`] || null;
}
